import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenu as UI_DropdownMenu,
} from "components/ui/dropdown-menu";
import { Button } from "components/ui/button";
import { toast } from "components/ui/use-toast";
import { useDialogModal } from "../../../../../hook/handle-modal/hooks/actions";
import { Trash, MoreHorizontal, Edit } from "lucide-react";
import { ICampaignRoulette, CampaignRouletteStatus } from "../../../../../@types/campaign-roulette";
import { useInactivateCampaignRouletteMutation } from "../../../../../services/campaign-roulette";
import { useNavigate } from "react-router-dom";
import { CAMPAIGN_MESSAGES } from "../../constants/messages";
import { InactivateConfirmModal } from "./InactivateConfirmModal";

function DropdownMenuComponent({
  trigger,
  row,
}: {
  trigger: React.ReactNode;
  row: ICampaignRoulette;
}) {
  const { handleModal } = useDialogModal();
  const navigate = useNavigate();
  const [inactivateCampaignRoulette, { isLoading }] = useInactivateCampaignRouletteMutation();

  const handleInactivate = async () => {
    try {
      await inactivateCampaignRoulette(row.id).unwrap();
      handleModal({ isOpen: false });
      toast(CAMPAIGN_MESSAGES.INACTIVATE.SUCCESS);
    } catch (error) {
      toast(CAMPAIGN_MESSAGES.INACTIVATE.ERROR);
    }
  };

  const handleEdit = () => {
    navigate(`/crm/gestao-campanha-roleta/editar/${row.id}`);
  };

  const openInactivateModal = () => {
    handleModal({
      isOpen: true,
      element: (
        <InactivateConfirmModal
          campaignName={row.nickname}
          onConfirm={handleInactivate}
          onCancel={() => handleModal({ isOpen: false })}
          isLoading={isLoading}
        />
      ),
      title: "Excluir Campanha",
    });
  };

  const isInactive = row.status === CampaignRouletteStatus.INATIVA;

  return (
    <>
      <UI_DropdownMenu>
        <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {!isInactive && (
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={handleEdit}
            >
              <Edit className="mr-2 h-4 w-4" />
              Editar
            </DropdownMenuItem>
          )}
          {!isInactive && (
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={openInactivateModal}
            >
              <Trash className="mr-2 h-4 w-4" />
              Inativar
            </DropdownMenuItem>
          )}
          {isInactive && (
            <DropdownMenuItem disabled>
              <span className="text-gray-400">Campanha inativa</span>
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </UI_DropdownMenu>
    </>
  );
}

export default function ActionTable({ row }: { row: ICampaignRoulette }) {
  return (
    <DropdownMenuComponent
      trigger={
        <Button variant="ghost" className="h-8 w-8 p-0 bg-transparent hover:bg-gray-100">
          <span className="sr-only">Abrir menu</span>
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      }
      row={row}
    />
  );
}
